module.exports = __webpack_public_path__ + "static/theknights-1f61ff2bc147c42907a10ae12294f245.jpg";